// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__ALoQn","overlay":"style_overlay__1c7QI","overlay_test":"style_overlay_test__2GIwW"};